// extracted by mini-css-extract-plugin
module.exports = {"followMe":"lx","linkItem":"ly","linkItemWrap":"lz","title":"lA","linkAppItemWrap":"lB","iconWrap":"lC","mfollowMe":"lD","miconWrap":"lE","followMe-dark":"lF","followMeDark":"lF"};